import { createContext, FunctionComponent, ReactNode } from 'react';

export const FeatureFlagContext = createContext<any>({
    featureFlagData: {}
});

export const FeatureFlagContextProvider: FunctionComponent<{
    children: ReactNode | ReactNode[];
    featureFlagConfiguration: any;
}> = ({ children, featureFlagConfiguration }) => {
    return <FeatureFlagContext.Provider value={featureFlagConfiguration}>{children}</FeatureFlagContext.Provider>;
};

export const FeatureFlagContextConsumer: FunctionComponent<{
    children: (value: any) => ReactNode | ReactNode[];
}> = FeatureFlagContext.Consumer;
